module.exports = __webpack_public_path__ + "static/media/fund_details_cover.27f6a3b2.png";